import React from 'react';
import {bindActionCreators} from 'redux';
import { connect } from 'react-redux';
import * as Actions from '../redux/actions'; //Import your actions
import 'materialize-css';
import Loading from '../Loading';
import AccountInfo from './AccountInfo';
import ProductInfo from './ProductInfo';
import VendorInfo from './VendorInfo';
// import Nav from '../components/Nav';

import preventRoboto from '../PreventRoboto';
//prevent react google maps from loading new roboto font on map load

import Autocomplete from '../components/Autocomplete';

import BusinessRoundedIcon from '@mui/icons-material/BusinessRounded';
import Inventory2RoundedIcon from '@mui/icons-material/Inventory2Rounded';
import DescriptionRoundedIcon from '@mui/icons-material/DescriptionRounded';
import EventRoundedIcon from '@mui/icons-material/EventRounded';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';

class LookupMain extends React.Component {

  constructor() {
    super();

    this.state = {
      searchList: [],
      searchValue: '',
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.info !== prevProps.info) {
      this.syncSearchFromInfo(this.props.info);
    }
  }

  syncSearchFromInfo(info) {
    if (!info) {
      this.setState({ searchValue: '' });
      return;
    }

    let label = '';
    if (info.type === 'product') {
      label = info.model;
    } else if (info.type === 'account' || info.type === 'vendor') {
      label = info.name;
    }

    if (label) {
      this.setState({ searchValue: label });
    }
  }

  lookupTypeFromUrl(type) {
    return ({ p: 'product', a: 'account', v: 'vendor' })[type];
  }

  syncFromUrl({ updateHistory = false } = {}) {
    const urlParams = new URLSearchParams(window.location.search);
    const infoType = urlParams.get('type');
    const infoId = urlParams.get('id');

    if (infoType && infoId) {
      const expectedType = this.lookupTypeFromUrl(infoType);
      const current = this.props.info;

      if (current && String(current.id) === String(infoId) && current.type === expectedType) {
        this.syncSearchFromInfo(current);
        return;
      }

      this.props.fetchInfo(
        this.props.authToken,
        infoId,
        infoType,
        null,
        { updateHistory }
      );
      return;
    }

    this.props.clearInfo();
    this.setState({ searchValue: '' });
  }

  handlePopState = () => {
    this.syncFromUrl();
  };

  componentDidMount() {
    console.log('component mounted at ', new Date().toISOString());
    preventRoboto();
    this.props.showNav(true);

    // Check URL parameters for direct navigation
    const urlParams = new URLSearchParams(window.location.search);
    const infoType = urlParams.get('type');
    const infoId = urlParams.get('id');

    window.addEventListener('popstate', this.handlePopState);

    // Fetch data sequentially using Promise chaining instead of nested callbacks
    this.props.fetchAccounts(this.props.authToken)
      .then(() => this.props.fetchProducts(this.props.authToken))
      .then(() => {
        this.setState({searchList: this.buildSearchList()});
        if (infoType && infoId) {
          this.syncFromUrl({ updateHistory: false });
        }
      })
      .then(() => this.props.fetchReportsList(this.props.authToken))
      .then(() => this.props.fetchScheduledServiceList(this.props.authToken))
      .then(() => this.props.fetchRecentlySearched(this.props.authToken))

    // document.getElementById("account-select").focus()
  }

  componentWillUnmount() {
    window.removeEventListener('popstate', this.handlePopState);
  }

  buildSearchList() {
    let productsList = (this.props.products || []).map(p => ({id: p.id, label: p.model, type: 'p'}));
    let accountsList = (this.props.accounts || []).map(a => ({id: a.id, label: a.name, type: 'a'}));
    let vendorsList = (this.props.vendors || []).map(v => ({id: v.id, label: v.name, type: 'v'}));
    return productsList?.concat(accountsList).concat(vendorsList);
  }

  handleOptionSelect(option) {
    this.setState({ searchValue: option.label });
    this.props.fetchInfo(this.props.authToken, option.id, option.type, null);
  }

  buildRecentlySearchedList(type) {
    let group = type === 'p' ? this.props.products : this.props.accounts;
    let recently_searched_list = (this.props.recentlySearched || []).filter(s => s.startsWith(type));
    return recently_searched_list
      .map(s => group?.find(item => item.id == s.slice(1)))
      .filter(Boolean);
  }

  renderPanel({ icon, count, label, bodyHeader, children, footer, accent }) {
    return (
      <div className={`lookup-panel lookup-panel--${accent}`}>
        <div className="lookup-panel-contents">
          <div className="lookup-panel-head">
            <div className="lookup-panel-icon">{icon}</div>
            <div className="lookup-panel-meta">
              <div className="lookup-panel-number">{count}</div>
              <div className="lookup-panel-label">{label}</div>
            </div>
          </div>
          <div className="lookup-panel-body">
            <div className="lookup-panel-body-header">{bodyHeader}</div>
            <div className="lookup-panel-list">{children}</div>
            {footer}
          </div>
        </div>
      </div>
    );
  }

  render() {
    const accounts = this.props.accounts || [];
    const products = this.props.products || [];
    const reports = this.props.reports || [];
    const scheduled = this.props.scheduledService || [];

    const recentAccounts = this.buildRecentlySearchedList('a').slice(0, 4);
    const recentProducts = this.buildRecentlySearchedList('p').slice(0, 4);
    const openDrafts = reports.filter(r => !r.submitted).reverse().slice(0, 4);
    const submittedThisMonth = reports.filter(r => r.submitted).length;
    const upcomingVisits = scheduled.slice(0, 4);

    return (
      <div className="lookup-container">

        {this.props.loading ? (
          <div className="loading-container-background"
            style={{position: 'absolute',width: '100%', height: '100%', backgroundColor: 'rgba(0, 0, 0, 0.7)', zIndex: '9999'}}
          >
            <Loading loading={this.props.loading} loadingMessage={this.props.loadingMessage} location={{top: '50%', left: '50%', height: '100%'}} height='120px'/>
          </div>
        ) : null}

        <div className="lookup-hero">
          <div className="lookup-hero-ambient" aria-hidden="true">
            <div className="lookup-hero-glow lookup-hero-glow--1" />
            <div className="lookup-hero-glow lookup-hero-glow--2" />
          </div>
          <div className="lookup-hero-card">
            <div className="lookup-hero-inner">
              <h1 className="lookup-hero-title">Lookup</h1>
              <p className="lookup-hero-subtitle">Search an account, product, or vendor</p>
              <div className="lookup-hero-search">
                <Autocomplete
                  list={this.state.searchList}
                  value={this.state.searchValue}
                  onChange={(searchValue) => this.setState({ searchValue })}
                  onSelect={(option) => this.handleOptionSelect(option)}
                  placeholder="Search for an account or product"
                  searchIcon
                />
              </div>
            </div>
          </div>
        </div>

        {this.props.info ? null : (
          <div className="lookup-panel-container">

            {this.renderPanel({
              accent: 'accounts',
              icon: <BusinessRoundedIcon />,
              count: accounts.length,
              label: accounts.length === 1 ? 'Account accessible' : 'Accounts accessible',
              bodyHeader: 'Recently viewed',
              children: recentAccounts.length > 0 ? (
                recentAccounts.map(a => (
                  <button
                    key={a.id}
                    className="lookup-list-item"
                    onClick={() => this.handleOptionSelect({id: a.id, label: a.name, type: 'a'})}
                  >
                    <span className="lookup-list-item-label">{a.name}</span>
                    <ArrowForwardRoundedIcon className="lookup-list-item-arrow" />
                  </button>
                ))
              ) : (
                <div className="lookup-empty">No recent accounts</div>
              ),
            })}

            {this.renderPanel({
              accent: 'products',
              icon: <Inventory2RoundedIcon />,
              count: products.length,
              label: products.length === 1 ? 'Product available' : 'Products available',
              bodyHeader: 'Recently viewed',
              children: recentProducts.length > 0 ? (
                recentProducts.map(p => (
                  <button
                    key={p.id}
                    className="lookup-list-item"
                    onClick={() => this.handleOptionSelect({id: p.id, label: p.model, type: 'p'})}
                  >
                    <span className="lookup-list-item-label">
                      <span className="lookup-list-item-strong">{p.model}</span>
                      {p.description ? <span className="lookup-list-item-sub"> &middot; {p.description}</span> : null}
                    </span>
                    <ArrowForwardRoundedIcon className="lookup-list-item-arrow" />
                  </button>
                ))
              ) : (
                <div className="lookup-empty">No recent products</div>
              ),
            })}

            {this.renderPanel({
              accent: 'reports',
              icon: <DescriptionRoundedIcon />,
              count: submittedThisMonth,
              label: 'Reports submitted this month',
              bodyHeader: 'Open drafts',
              children: openDrafts.length > 0 ? (
                openDrafts.map(r => (
                  <a key={r.id} href={`/reports/edit?${r.id}`} className="lookup-list-item">
                    <span className="lookup-list-item-label">{r.title}</span>
                    <ArrowForwardRoundedIcon className="lookup-list-item-arrow" />
                  </a>
                ))
              ) : (
                <div className="lookup-empty">No open drafts</div>
              ),
              footer: (
                <a href="/reports" className="lookup-panel-footer-link">
                  View all reports
                  <ArrowForwardRoundedIcon />
                </a>
              ),
            })}

            {/* {this.renderPanel({
              accent: 'schedule',
              icon: <EventRoundedIcon />,
              count: scheduled.length,
              label: scheduled.length === 1 ? 'Service visit this week' : 'Service visits this week',
              bodyHeader: 'Upcoming',
              children: upcomingVisits.length > 0 ? (
                upcomingVisits.map(e => (
                  <a key={e.id} href="/schedule" className="lookup-list-item">
                    <span className="lookup-list-item-label">{e.title}</span>
                    <ArrowForwardRoundedIcon className="lookup-list-item-arrow" />
                  </a>
                ))
              ) : (
                <div className="lookup-empty">Nothing scheduled</div>
              ),
              footer: (
                <a href="/schedule" className="lookup-panel-footer-link">
                  View schedule
                  <ArrowForwardRoundedIcon />
                </a>
              ),
            })} */}

          </div>
        )}

        <AccountInfo />
        <ProductInfo />
        <VendorInfo />
      </div>
    )
  }
}

function mapStateToProps(state, props) {
  return {
    authToken: state.authToken,
    info: state.info,
    pastSearches: state.pastSearches,
    products: state.products,
    vendors: state.vendors,
    accounts: state.accounts,
    reports: state.reports,
    scheduledService: state.scheduledService,
    recentlySearched: state.recentlySearched,
    user: state.user,
    loading: state.loading,
    loadingMessage: state.loadingMessage
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(LookupMain);
